// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","social_list":"Footer_social_list__LkFRE","copy_right":"Footer_copy_right__diL20"};